import React from 'react';
import { IndicatorPoint } from '../../types/census';
const W = 560;
const H = 200;
const PAD = {
  l: 36,
  r: 20,
  t: 24,
  b: 30
};
export function TrendChart({
  points,
  label
}: {
  points: IndicatorPoint[];
  label: string;
}) {
  if (points.length === 0) {
    return <p className="py-10 text-center text-sm text-muted" data-id="element-353" data-mp="2tn4es6c191bu">No trend data reported for this country.</p>;
  }
  const vals = points.map(p => p.value);
  const min = Math.max(0, Math.floor((Math.min(...vals) - 5) / 10) * 10);
  const max = Math.min(100, Math.ceil((Math.max(...vals) + 5) / 10) * 10);
  const x = (i: number) => points.length === 1 ? (PAD.l + W - PAD.r) / 2 : PAD.l + i / (points.length - 1) * (W - PAD.l - PAD.r);
  const y = (v: number) => PAD.t + (1 - (v - min) / Math.max(1, max - min)) * (H - PAD.t - PAD.b);
  const d = points.map((p, i) => `${i === 0 ? 'M' : 'L'}${x(i)},${y(p.value)}`).join(' ');
  return <figure data-id="element-354" data-mp="3hb5eqqv5b9fn">
      <svg viewBox={`0 0 ${W} ${H}`} className="h-auto w-full" role="img" aria-label={`${label}: ${points.map(p => `${p.year} ${p.value.toFixed(1)}%`).join(', ')}`} data-id="element-355" data-mp="3hbdvwuyax0wn">
        {[min, (min + max) / 2, max].map(t => <g key={t} data-id="element-356" data-mp="nwtp6rwqjpex">
            <line x1={PAD.l} x2={W - PAD.r} y1={y(t)} y2={y(t)} stroke="rgb(var(--c-line))" strokeWidth={1} data-id="element-357" data-mp="o0hipr26kbtn" />
            <text x={PAD.l - 8} y={y(t) + 4} textAnchor="end" className="fill-[rgb(var(--c-muted))] font-mono text-[10px]" data-id="element-358" data-mp="ry5jhaqk0ytg">
              {Math.round(t)}%
            </text>
          </g>)}
        <path d={d} fill="none" stroke="rgb(var(--c-human))" strokeWidth={2} data-id="element-359" data-mp="6zccacf20uo" />
        {points.map((p, i) => <g key={p.year} data-id="element-360" data-mp="99h22yra5bmf" data-mpi={i}>
            <circle cx={x(i)} cy={y(p.value)} r={3.5} fill="rgb(var(--c-bg))" stroke="rgb(var(--c-human))" strokeWidth={2} data-id="element-361" data-mp="998kwuo4jk5f" />
            <text x={x(i)} y={y(p.value) - 10} textAnchor="middle" className="fill-[rgb(var(--c-ink))] font-mono text-[11px]" data-id="element-362" data-mp="e1s17ze74tdx">
              {p.value.toFixed(1)}
            </text>
            <text x={x(i)} y={H - 8} textAnchor="middle" className="fill-[rgb(var(--c-muted))] font-mono text-[10.5px]" data-id="element-363" data-mp="3ho8v29nes84v">
              {p.year}
            </text>
          </g>)}
      </svg>
    </figure>;
}